import { useThread } from "../hooks/useThread";
import { AsyncResult } from "../../shared";
import { ThreadMessageView } from "./ThreadMessageView";
import { useParams } from "react-router";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { useWorkspace } from "../../workspace";
import s from "./ThreadView.module.css";

export function ThreadViewContent() {
  const params = useParams<{ threadId: string }>();
  const { workspace_id } = useWorkspace();
  const query = useThread(workspace_id, params.threadId!);
  const { setThreadKnowledge } = query;

  return (
    <div className={s.threadView}>
      <AsyncResult query={query}>
        {(thread) => (
          <ThreadMessageView
            thread={thread}
            setThreadKnowledge={setThreadKnowledge}
          />
        )}
      </AsyncResult>
    </div>
  );
}

export function ThreadView() {
  return (
    <WorkspaceScreen>
      <ThreadViewContent />
    </WorkspaceScreen>
  );
}
